import { Section, SHELL, LINE, INSET_X } from '@/components/base/Frame';
import SectionLabel from '@/components/base/SectionLabel';
import { workingSteps } from '@/mocks/home';

export default function WorkingTogether() {
  return (
    <Section id="working-together" autoHeight>
      <div className={`${SHELL} flex flex-1 flex-col pt-8`}>
        <div className={`flex flex-col gap-6 md:flex-row md:items-end md:justify-between md:gap-12 ${INSET_X}`}>
          <div>
            <SectionLabel index="05" label="Working Together" />
            <h2 className="reveal-up mt-4 text-3xl font-light leading-[1.1] tracking-[-0.02em] text-foreground-950 lg:text-[clamp(30px,2.9vw,42px)]">
              What happens after you reach out.
            </h2>
          </div>
          <p className="max-w-[24rem] text-base leading-relaxed text-foreground-700">
            A practical starting point, a clear scope, and a plan built around the way your team works.
          </p>
        </div>

        <div aria-hidden="true" className="min-h-14 flex-1 md:min-h-20" />
        <ol className={`border-t ${LINE}`}>
          {workingSteps.map((s) => (
            <li
              key={s.index}
              className={`wt-row reveal-up group relative grid grid-cols-[40px_1fr] gap-x-4 gap-y-2 border-b ${LINE} last:border-b-0 py-7 ${INSET_X} transition-colors duration-300 ease-out hover:bg-primary-50/60 md:grid-cols-[56px_minmax(0,4fr)_minmax(0,7fr)] md:gap-x-8 md:py-9`}
            >
              <span aria-hidden="true" className="absolute inset-y-0 left-0 w-px origin-top scale-y-0 bg-primary-500 transition-transform duration-300 ease-out group-hover:scale-y-100" />
              <span className="pt-1 font-label text-[13px] font-medium tracking-[0.1em] text-foreground-500 transition-colors duration-300 group-hover:text-primary-500">
                {s.index}
              </span>
              <h3 className="text-2xl font-light tracking-[-0.015em] text-foreground-950 lg:text-[26px]">{s.title}</h3>
              <p className="col-start-2 max-w-[36rem] text-base leading-relaxed text-foreground-700 md:col-start-3 md:row-start-1">{s.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </Section>
  );
}